module.exports = __webpack_public_path__ + "static/img/IPv6.b317aef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/IPv6.png
// module id = jAII
// module chunks = 16